var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer",class:_vm.selectedProject === this.data.uuid ? 'bg-green bg-opacity-10' : '',on:{"click":_vm.toggleSelectedProject}},[_c('draft-description',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }